import React from 'react'

import { useSelector } from 'react-redux'

import { IApplicationState } from '@store'
import { selectBrandFanGroupIds } from '@store/brandFans'
import { GroupListContainer } from './Groups.styled'
import BrandFansInfluencerIdentityGroupsItem from './Item'

interface IProps {
  identityId: number
  influencerId?: number
  submissionId?: number
  campaignId?: number
  identityGroupIds: ReadonlyArray<number>
  onScroll?: (event: React.UIEvent<HTMLElement>) => void
}

const BrandFansInfluencerIdentityGroupsList: React.FC<IProps> = ({
  identityId,
  submissionId,
  identityGroupIds,
  campaignId,
  influencerId,
  onScroll,
}) => {
  const groupIds = useSelector((state: IApplicationState) => selectBrandFanGroupIds(state))
  return (
    <GroupListContainer data-testid="brand-fan-groups-list-container" onScroll={onScroll}>
      {groupIds.map((groupId) => (
        <BrandFansInfluencerIdentityGroupsItem
          isMemberOfGroup={identityGroupIds.includes(groupId)}
          submissionId={submissionId}
          campaignId={campaignId}
          key={groupId}
          groupId={groupId}
          identityId={identityId}
          influencerId={influencerId}
        />
      ))}
    </GroupListContainer>
  )
}

export { BrandFansInfluencerIdentityGroupsList }
export default BrandFansInfluencerIdentityGroupsList
